import {
    CHECKING_GET_STATUS,
    CHECKING_RECORD,
    CHECKING_SET_LOADING,
    CHECKING_CLEAR
} from '../actions/checkingActions'

const initialState = {
    connected: false,
    checking: null,
    summary: null,
    loading: false
}

const checkingReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECKING_GET_STATUS:
            return {
                ...state,
                connected: action.payload.connected,
                checking: action.payload.checking,
                summary: action.payload.summary
            }
        case CHECKING_RECORD:
            return {
                ...state,
                checking: action.payload.checking,
                summary: action.payload.summary
            }
        case CHECKING_SET_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case CHECKING_CLEAR:
            return initialState
        default:
            return state
    }
}

export default checkingReducer
